
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"-1715 -20422 32 32.074"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Group_12588","data-name":"Group 12588","transform":"translate(-1715 -20421.999)"}},[_c('path',{attrs:{"id":"Path_19910","d":"M32 16.037A16 16 0 1 1 16.037 0 16.013 16.013 0 0 1 32 16.037","data-name":"Path 19910","fill":"#ffcc4d"}}),_c('path',{staticClass:"cls-2",attrs:{"id":"Path_19911","d":"M14.774 18.482c0 1.79-1.044 3.282-2.387 3.282-1.268 0-2.387-1.492-2.387-3.282s1.044-3.282 2.387-3.282 2.387 1.417 2.387 3.282","data-name":"Path 19911","transform":"translate(-2.541 -3.862)"}}),_c('path',{staticClass:"cls-2",attrs:{"id":"Path_19912","d":"M31.174 18.482c0 1.79-1.044 3.282-2.387 3.282-1.268 0-2.387-1.492-2.387-3.282s1.044-3.282 2.387-3.282 2.387 1.417 2.387 3.282","data-name":"Path 19912","transform":"translate(-6.708 -3.862)"}}),_c('path',{staticClass:"cls-2",attrs:{"id":"Path_19913","d":"M25.472 30.939H12.27a.97.97 0 1 1 0-1.939h13.2a.97.97 0 1 1 0 1.939","data-name":"Path 19913","transform":"translate(-2.871 -7.368)"}})])])
          )
        }
      }
    